import type {
  AircraftApplicabilityCreate,
  CustomerApplicabilityCreate,
  QuoteRulesetCreate,
} from "@common/client"
import { z } from "zod"

export const playbookSchema = z.object({
  name: z.string().trim().min(1, "Name is required"),
  customer_id: z.string().nullable(),
  type_certificate_model_variant_id: z.string().nullable(),
  rule: z.string().trim().min(1, "Write the first rule"),
})

export type PlaybookFormInput = z.input<typeof playbookSchema>

export const emptyPlaybook: PlaybookFormInput = {
  name: "",
  customer_id: null,
  type_certificate_model_variant_id: null,
  rule: "",
}

export function customerSubject(
  customerId: string | null,
): CustomerApplicabilityCreate[] {
  return customerId ? [{ subject: "customer", customer_id: customerId }] : []
}

export function aircraftSubject(
  variantId: string | null,
): AircraftApplicabilityCreate[] {
  return variantId
    ? [{ subject: "aircraft", type_certificate_model_variant_id: variantId }]
    : []
}

export function toPlaybookCreate(
  values: PlaybookFormInput,
): QuoteRulesetCreate {
  return {
    name: values.name,
    version: {
      rules: [{ content: values.rule }],
      applicability: [
        ...customerSubject(values.customer_id),
        ...aircraftSubject(values.type_certificate_model_variant_id),
      ],
    },
  }
}
